export { default } from "./BannerContentWrapper";
